module.exports = __webpack_public_path__ + "img/wedo_pict04.abc3e72e.png";